export const TA_BACKGROUND = 'rgb(126, 39, 188)';
export const PLAYER1 = 'PLAYER 1';
export const PLAYER2 = 'PLAYER 2';
export const DRAW = 'DRAW';
export const ALTERNATE = 'ALTERNATE';
export const DISABLED = 'DISABLED';
export const SELECTED = 'SELECTED';
export const BEGINNER = 'BEGINNER';
export const JUNIOR = 'JUNIOR';
export const SENIOR = 'SENIOR';
export const GRADUATE = 'GRADUATE';
export const HUMAN_VS_ROBOT = 'HUMAN VS ROBOT';
export const HUMAN_VS_HUMAN = 'HUMAN VS HUMAN';
export const DOT_SIZE = 9;
export const PLAYER1_COLOR = 'rgb(204, 0, 204)';
export const PLAYER2_COLOR = 'rgb(0, 128, 128)';
export const OPTIONS_KEY = 'TA OPTIONS';
export const HINT = 'HINT';
export const SEEN_OPTIONS_KEY = 'TA SEEN OPTIONS';
export const YOUTUBE_TA = 'https://youtu.be/A_5dIYh0Moc';
